import { render, staticRenderFns } from "./pengajuan_form.vue?vue&type=template&id=7c89dec6&"
import script from "./pengajuan_form.vue?vue&type=script&lang=js&"
export * from "./pengajuan_form.vue?vue&type=script&lang=js&"
import style0 from "./pengajuan_form.vue?vue&type=style&index=0&id=7c89dec6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports